// extracted by mini-css-extract-plugin
module.exports = {"hashtags":"GoIO9","hashtag":"_3nZRe"};